// extracted by mini-css-extract-plugin
export default {"Section":"get-home_Section__AvoDx","SpecialOffers":"get-home_SpecialOffers__NQNjG"};